import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "primeicons/primeicons.css";
import { BrowserRouter } from "react-router-dom";
import { PrimeReactProvider } from "primereact/api";
import { Provider } from "react-redux";
import {getStore} from "./states/store";
import "./assets/i18next/config";
import "primeflex/primeflex.css";
import "primereact/resources/primereact.css";
import { CookiesProvider } from "react-cookie";
const { store } = getStore();
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  // <React.StrictMode>

  <PrimeReactProvider>

    <Provider store={store}>
      <BrowserRouter>
      <CookiesProvider defaultSetOptions={{ path: "/" }}>
        <App />
        </CookiesProvider>
      </BrowserRouter>
    </Provider>

  </PrimeReactProvider>

  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
